export const MAP_CURRENCY_LOCAL: {[key: string]: string} = {
  'EUR': 'de',
  'NOK': 'de',
  'DKK': 'da',
  'SEK': 'se',
};
